import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatTableDataSource, MatTable, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell } from '@angular/material/table';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { takeUntil } from 'rxjs/operators';
import { CvdDongleService } from './../../../../services';
import { CvdDongleInfo } from '../../models';
import { RouterLink } from '@angular/router';
import { MatDivider } from '@angular/material/list';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'insight-cvd-dongle-info',
  templateUrl: './cvd-dongle-info.component.html',
  styleUrls: ['./cvd-dongle-info.component.scss', '../../scss/operational-dashboard-shared.scss'],
  imports: [RouterLink, MatDivider, MatTable, MatSort, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, DatePipe]
})
export class CvdDongleInfoComponent implements OnInit, OnDestroy {
  public dataSource = new MatTableDataSource<CvdDongleInfo>();
  public displayedColumns: string[] = [
    'workstationName',
    'expires',
    'pinPlayCreditsRemaining',
    'patronusCreditsRemaining',
    'patronusVersion'
  ];

  private unsubscribeTrigger$ = new Subject();

  constructor(
    private cvdDongleInfoService: CvdDongleService,
    private toastr: ToastrService) { }

  ngOnInit(): void {

    this.cvdDongleInfoService.getCvdDongleInfo()
      .pipe(takeUntil(this.unsubscribeTrigger$))
      .subscribe(result => {
        this.dataSource = new MatTableDataSource(result);
      }, (error: any) => {
        this.toastr.error('Failed to get CVD Dongle Information records', 'Error');
      });
  }

  ngOnDestroy() {
    this.unsubscribeTrigger$.next();
    this.unsubscribeTrigger$.complete();
  }
}
